<apx-chart
[series]="chartOptions?.series"
[chart]="chartOptions?.chart"
[plotOptions]="chartOptions?.plotOptions"
[labels]="chartOptions?.labels"
[fill]="chartOptions?.fill"
[title]="chartOptions?.title"
></apx-chart>
